var _path, _path2, _path3, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThreeRoom = function SvgThreeRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M51.865 10.53V56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.156,
    d: "M61.885 10.53V56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1 10.145h60.885"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "three-room_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 10.79,
    x: 9.863,
    y: 19.006,
    rx: 0.771
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 10.79,
    x: 9.863,
    y: 19.006,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#three-room_svg__a)",
    rx: 0.771
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "three-room_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 10.79,
    x: 22.194,
    y: 19.006,
    rx: 0.771
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 10.79,
    x: 22.194,
    y: 19.006,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#three-room_svg__b)",
    rx: 0.771
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "three-room_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 10.79,
    x: 34.525,
    y: 19.006,
    rx: 0.771
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 10.79,
    x: 34.525,
    y: 19.006,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#three-room_svg__c)",
    rx: 0.771
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.156,
    d: "m1 10.53 7.707-9.25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m51.865 10.53-7.707-9.25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.156,
    d: "M1 55.228v-44.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.707 1.281 1 10.144V56h60.885V10.144l-8.093-8.863z"
  })));
};
export default SvgThreeRoom;